module.exports = __webpack_public_path__ + "img/solar-panel.981632ef.png";